import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { translate } from 'react-i18next';

const Container = styled.div`
	padding: 40px 0 0;
`;

const Label = styled.p`
	font-size: 12px;
	color: #9B9B9B;
	margin: 0 0 8px;
`;

const Range = styled.input`
	width: 100%;
`;

const Scale = props => {
	const { t } = props;
	return (
		<Container>
			<Label>{t('controls/image/scale/label', { scale: props.scale })}</Label>
			<Range
				type="range"
				min="0.1"
				max="3"
				step="0.05"
				value={props.scale}
				onChange={event => props.changesHandler({ scale: Number(event.target.value) })}
			/>
		</Container>
	)
}

Scale.propTypes = {
	t: PropTypes.func,
	scale: PropTypes.number,
	changesHandler: PropTypes.func,
}

export default translate('translations')(Scale)
